<template>
  <header class="cs-header">
    <div class="logo-container">
      <img class="cs-logo" src="@/assets/img/logo.png" />
    </div>

    <div class="nav-container">
      <NavbarComponent> </NavbarComponent>
    </div>
  </header>
  <router-view />

  <footer class="cs-footer">
    <div class="cs-footer-content">
      <img class="cs-logo-footer" src="@/assets/img/logo.png" />
      <div class="cs-footer-right">
        <div class="cs-footer-links">
          <router-link to="/terms-of-service">Terms of Use</router-link>
          <router-link to="/privacy-policy">Privacy Policy</router-link>
          <a href="https://app.vanta.com/coreslicer.com/trust/5fz9w07t82cszqzgpr7w6g" target="_blank" rel="noopener noreferrer">Trust Center</a>
          <a href="https://coreslicer.statuspage.io/" target="_blank" rel="noopener noreferrer">Status Page</a>
          <a href="mailto:info@coreslicer.com">Contact Us</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import NavbarComponent from "@/components/navbar-component.vue";

export default {
  name: "App",
  components: {
    NavbarComponent,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #1c1c1d;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.cs-header .p-menubar {
  background: transparent;
  border: none;
  font-family: "Avenir-Medium";
  font-size: 16px;
  font-weight: 800;
  color: white;
}

.cs-header
  .p-menubar
  .p-menuitem:not(p.highlight):not(p.disabled).p-focus
  > .p-menuitem-content {
  background: transparent;
}

@media screen and (max-width: 960px) {
  .cs-header .p-menubar.p-menubar-mobile-active .p-menubar-root-list {
    left: -160px;
  }

  .cs-header .p-menubar .p-menubar-root-list {
    width: 200px;
  }
}

.cs-header {
  padding-left: 0px;
  padding-right: 0px;
  max-width: 1440px;
  margin: 0 auto;
  height: 72px;
  width: 100%;
  background-color: #1c1c1d;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 60px;
  z-index: 1;
  position: relative;
}

.cs-header > * {
  z-index: 2;
}

.logo-container {
  display: flex;
  flex-direction: row;
}

.nav-container {
  display: flex;
  position: absolute;
  right: 0;
}

.cs-logo {
  object-fit: contain;
  height: 80px;
}

@media screen and (max-width: 1550px) {
  .cs-header {
    padding-left: 20px;
    padding-right: 20px;
  }
}

@media screen and (max-width: 640px) {
  .cs-logo {
    height: 40px;
  }
}

@media screen and (max-width: 900px) {
  .cs-header {
    padding-left: 20px;
    padding-right: 20px;
  }
}

@media screen and (max-width: 425px) {
  .cs-header {
    padding-left: 10px;
    padding-right: 10px;
  }
}

.cs-footer {
  width: 100%;
  height: 372px;
  bottom: 0;
  margin: 0 auto;
  background-color: black;
  width: 100%;
  height: 170px;
  bottom: 0;
  display: flex;
  flex-direction: row;
  padding-top: 30px;
  padding-bottom: 30px;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.cs-footer-content {
  max-width: 1440px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  position: relative;
}

.cs-logo-footer {
  height: 80px;
}

.cs-footer-right {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 24px;
}

.cs-footer-links {
  display: flex;
  flex-direction: row;
  gap: 20px;
  height: 70px;
  align-items: center;
}

.cs-footer-links a {
  text-decoration: underline;
  color: #77b3f0;
  font-family: "Avenir-Light";
  font-size: 20px;
  line-height: 25px;
  cursor: pointer;
}

.cs-footer-contact {
  display: flex;
  flex-direction: column;
}
</style>
